export type RuntimeConfig = {
  BACKEND?: string;
  STATIC?: string;
};

declare global {
  interface Window {
    __env?: RuntimeConfig;
  }
}

export function readRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.__env || {};
}
